import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useContactsPageLayoutContext } from 'pages/contacts/context/contactsPageLayoutContext'
import { HistoryPageStore } from 'pages/contacts/pages/history/store/historyPageStore'
import { ProviderHistoryPage } from 'pages/contacts/pages/history/context/historyPageContext'

const HistoryLayoutContent = observer(() => {
  return <Outlet />
})

export const HistoryLayout = observer(() => {
  const { pageLayoutStore } = useContactsPageLayoutContext()
  const entities = useEntitiesContext()
  const [store] = useState(() => new HistoryPageStore(pageLayoutStore, entities))

  return (
    <ProviderHistoryPage value={store}>
      <HistoryLayoutContent />
    </ProviderHistoryPage>
  )
})
